<template>
  <div>
    <h1 class="h2 mt-4">Díjfizetés És Kedvezmények</h1>
    <div class="mb-3">
      <div class="w-100 label pb-2">
        <b
          >Milyen díjfizetési módot szeretne választani? <span class="text-danger">*</span>
          <span
            class="info"
            id="dijfizetes_modja-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></b
        >
      </div>
      <div class="row">
        <input type="text" hidden v-model="paymentType" name="dijfizetes_mod" />
        <div class="col-md-3 form-group mb-2">
          <button
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click.prevent="paymentType = 'csoportos'"
            :class="{
              'btn-red': paymentType == 'csoportos',
              'btn-outline-danger': paymentType !== 'csoportos',
            }"
          >
            Csoportos beszedési megbízás
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click.prevent="paymentType = 'online'"
            :class="{
              'btn-red': paymentType == 'online',
              'btn-outline-danger': paymentType !== 'online',
            }"
          >
            Online bankkártyás fizetés
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click.prevent="paymentType = 'atutalas'"
            :class="{
              'btn-red': paymentType == 'atutalas',
              'btn-outline-danger': paymentType !== 'atutalas',
            }"
          >
            Átutalás
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click.prevent="paymentType = 'csekk'"
            :class="{
              'btn-red': paymentType == 'csekk',
              'btn-outline-danger': paymentType !== 'csekk',
            }"
          >
            Postai csekk
          </button>
        </div>
      </div>
      <small id="dijfizetes_modja-error" class="text-danger input-alert"></small>
    </div>
    <div v-if="paymentType === 'csoportos'">
      <h1 class="h2 mt-4">Bank adatok</h1>
      <div class="row justify-content-end">
        <ValidationProvider
          rules="required|bankszamlaszam|bankszamlaszam_alg"
          v-slot="{errors, classes}"
          class="col-md-8 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_bankszamlaszam"
                class="input-group-text"
                id="szerzodo_bankszamlaszam_prepend"
                >Számlaszám: <span class="text-danger">*</span></label
              >
            </div>
            <input
              v-mask="'########-########-########'"
              type="text"
              class="form-control dark-border"
              id="szerzodo_bankszamlaszam"
              name="szerzodo_bankszamlaszam"
              v-model="bankAccountNumber"
              aria-label="szerzodo_bankszamlaszam"
              aria-describedby="szerzodo_bankszamlaszam_prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_bankszamlaszam-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row justify-content-end">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-8 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label for="szerzodo_bankneve" class="input-group-text" id="szerzodo_bankneve_prepend"
                >Bank neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_bankneve"
              name="szerzodo_bankneve"
              v-model="bankName"
              aria-label="szerzodo_bankneve"
              aria-describedby="szerzodo_bankneve_prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_bankneve-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row justify-content-end">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-8 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_szamlatulajdonosneve"
                class="input-group-text"
                id="szerzodo_szamlatulajdonosneve_prepend"
                >Számlatulajdonos neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_szamlatulajdonosneve"
              name="szerzodo_szamlatulajdonosneve"
              v-model="bankAccountHolderName"
              aria-label="szerzodo_szamlatulajdonosneve"
              aria-describedby="szerzodo_szamlatulajdonosneve_prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_szamlatulajdonosneve-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Milyen díjfizetési gyakorisággal szeretné fizetni a szerződés díját?
        <span class="text-danger">*</span>
        <span
          class="info"
          id="dijfizetes_gyakorisaga-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        ></label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_year"
            :value="'eves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_year">
            Éves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_halfyear"
            :value="'feleves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_halfyear">
            Féléves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_quarterly"
            :value="'negyedeves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_quarterly">
            Negyedéves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_month"
            :value="'havi'"
            :disabled="!canChooseMonthlyPayment"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_month">
            Havi
          </label>
        </div>
        <small id="dijfizetes_gyakorisaga-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Szeretné, ha a Biztosító (postai levelezés helyett) elektronikus formában kommunikálna
        Önnel? <span class="text-danger">*</span>
        <span
          class="info"
          id="elektronikus_kommunikacio-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_igen"
            :value="1"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_nem"
            :value="0"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kommunikáció választásakor további -5% kedvezményt adunk az éves
          díjból.</small
        ><br />
        <span v-if="!electronicContact"
          ><small class="text-warning fw-bold input-alert">
            Ebben az esetben az összes dokumentumot kinyomtatjuk és postán is küldjük Önnek. Ez egy
            sokkal lassabb és környezetszennyezőbb folyamat, valamint így nem takarít meg 5%-ot a
            végső árból. </small
          ><br
        /></span>

        <small id="elektronikus_kommunikacio-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">
        Szeretné a kárrendezést (személyes ügyintézés vagy postai levelezés helyett)
        elektronikusan/digitálisan végezni?
        <span class="text-danger">*</span>
        <span
          class="info"
          id="elektronikus_karrendezes-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_igen"
            :value="1"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_nem"
            :value="0"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kárrendezés választásakor további -2% kedvezményt adunk az éves
          díjból.</small
        ><br />
        <small id="ekarrendezes-error" class="text-danger input-alert"></small>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  data() {
    return {
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      frequencyPrice: 0,
    };
  },
  computed: {
    ...mapFields([
      'generalInfo.contractFor',
      'insuranceProperty.chosenInsurancePrice',
      'insurancePersonalGoods.calculatedInsurancePrice',
      'insurancePersonalGoods.acceptCalculatedInsurance',
      'insurancePersonalGoods.priceType',
      'insurancePersonalGoods.allGoodsPrice',
      'insurancePersonalGoods.summaryInputs',
      'insurancePersonalGoods.valuablesUnder200',
      'chooseableAccesories.valuablesAbove200',
      'chooseableAccesories.valuablesAboveInputs',
      'chooseableAccesories.accidentInsuranceType',
      'electronicContact',
      'electronicInsuring',
    ]),
    ...mapFields({
      sideBuildings: 'insuranceSideBuildings.list',
      jewelryPrice: 'chooseableAccesories.valuablesAboveInputs.jewelry',
      antiquesPrice: 'chooseableAccesories.valuablesAboveInputs.antiques',
      exoticTextilePrice: 'chooseableAccesories.valuablesAboveInputs.exotic',
      collectionPrice: 'chooseableAccesories.valuablesAboveInputs.collection',
      accesoriesList: 'chooseableAccesories.selectableList',
      insuredPersonTemplate: 'chooseableAccesories.travelInsuranced.template',
      insuredPersons: 'chooseableAccesories.travelInsuranced.list',
      paymentType: 'paymentOptions.type',
      paymentFrequency: 'paymentOptions.frequency',
      eves_dij_csokkentett: 'kieg_kedv_dij',
      gyakorisagdij: 'gyakorisag_dij_havi',
      bankAccountNumber: 'contractSettings.bankAccountNumber',
      bankName: 'contractSettings.bankName',
      bankAccountHolderName: 'contractSettings.bankAccountHolderName',
      bankCodeList: 'bankCodes',
    }),
    canChooseMonthlyPayment() {
      return !(this.gyakorisagdij < 2000);
    },
  },
  watch: {
    paymentFrequency: function(value) {
      if (value == 'havi' && !this.canChooseMonthlyPayment) this.paymentFrequency = 'negyedeves';
    },
    bankAccountNumber: function(newValue, oldValue) {
      if (newValue.length >= 3) {
        if (
          newValue.slice(0, 3) in this.bankCodeList &&
          newValue.slice(0, 3) !== oldValue.slice(0, 3)
        ) {
          this.$store.commit('updateContractSettings', {
            name: 'bankName',
            value: this.bankCodeList[parseInt(newValue.slice(0, 3))],
          });
        }
      }
      if (newValue.length < 3) {
        this.$store.commit('updateContractSettings', {
          name: 'bankName',
          value: '',
        });
      }
      if (!(newValue.slice(0, 3) in this.bankCodeList)) {
        this.$store.commit('updateContractSettings', {
          name: 'bankName',
          value: '',
        });
      }
    },
  },
  mounted() {
    if (this.paymentFrequency == 'havi' && !this.canChooseMonthlyPayment)
      this.paymentFrequency = 'negyedeves';
  },
};
</script>
